// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FilePreviewModal-module__Iframe__S_2Fz {
    width: 100%;
    height: 100%;
    border: 0;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Iframe": `FilePreviewModal-module__Iframe__S_2Fz`
};
export default ___CSS_LOADER_EXPORT___;
